import { c as _c } from "react/compiler-runtime";
import styles from "./SeasonsDropdown.module.scss";
import { Dropdown } from "react-bootstrap";
interface Props {
  seasons: number[];
  selectedSeason: number;
  setSelectedSeason(season: number): void;
}
export default function SeasonsDropdown(props) {
  const $ = _c(11);
  const t0 = props.selectedSeason === 0 ? "All" : props.selectedSeason;
  let t1;
  if ($[0] !== t0) {
    t1 = <Dropdown.Toggle>SZN: {t0}</Dropdown.Toggle>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] !== props) {
    t2 = <Dropdown.Item onClick={() => {
      props.setSelectedSeason(0);
    }}>All</Dropdown.Item>;
    t3 = props.seasons.map(s => <Dropdown.Item key={`season-${s}`} onClick={() => {
      props.setSelectedSeason(s);
    }}>SZN{s}</Dropdown.Item>);
    $[2] = props;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <Dropdown.Menu>{t2}{t3}</Dropdown.Menu>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <Dropdown className={styles.seasonDropdown} drop="down-centered">{t1}{t4}</Dropdown>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}